import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkCenterLabel } from '../../../models/work-center-label.model';
import { WorkCenterLabelService } from '../../../services/work-center-label.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-label-management-dialog',
  templateUrl: './label-management-dialog.component.html',
  standalone: false,
})
export class LabelManagementDialogComponent {
  @Input() visible = false;
  @Input() labels: WorkCenterLabel[] = [];
  @Input() loading = false;
  @Input() workCenterId = '';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() labelsChanged = new EventEmitter<void>();

  newLabelText = '';
  editingLabel: WorkCenterLabel | null = null;
  editLabelText = '';
  saving = false;

  constructor(
    private workCenterLabelService: WorkCenterLabelService,
    private confirmationService: ConfirmationService,
  ) {}

  onDialogHide(): void {
    // Cleanup when dialog closes
    this.cancelEdit();
    this.newLabelText = '';
    // Properly emit the visibility change to parent
    this.visible = false;
    this.visibleChange.emit(false);
  }

  createLabel(): void {
    const trimmed = this.newLabelText.trim();
    if (!trimmed || !this.workCenterId) return;

    this.saving = true;
    this.workCenterLabelService
      .create({ label: trimmed, workCenterFK: this.workCenterId })
      .subscribe({
        next: () => {
          this.newLabelText = '';
          this.saving = false;
          this.labelsChanged.emit();
        },
        error: () => {
          this.saving = false;
        },
      });
  }

  startEdit(label: WorkCenterLabel): void {
    this.editingLabel = label;
    this.editLabelText = label.label;
  }

  cancelEdit(): void {
    this.editingLabel = null;
    this.editLabelText = '';
  }

  saveEdit(): void {
    if (!this.editingLabel) return;
    const trimmed = this.editLabelText.trim();
    if (!trimmed) return;

    this.saving = true;
    this.workCenterLabelService
      .update({ uid: this.editingLabel.uid, label: trimmed })
      .subscribe({
        next: () => {
          this.cancelEdit();
          this.saving = false;
          this.labelsChanged.emit();
        },
        error: () => {
          this.saving = false;
        },
      });
  }

  confirmDelete(label: WorkCenterLabel): void {
    this.confirmationService.confirm({
      message: `Êtes-vous sûr de vouloir supprimer l'étiquette « ${label.label} » ?`,
      header: 'Confirmation de suppression',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Supprimer',
      rejectLabel: 'Annuler',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.deleteLabel(label),
    });
  }

  private deleteLabel(label: WorkCenterLabel): void {
    this.saving = true;
    this.workCenterLabelService.delete(label.uid).subscribe({
      next: () => {
        this.saving = false;
        this.labelsChanged.emit();
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
